import { instance } from '@/services/avik-api-gateway'
import { VehicleTypeGroup } from '@/types/vehicle-type-group'
import { AxiosResponse } from 'axios'

export function createVehicleTypeGroup(
  body: VehicleTypeGroup
): Promise<AxiosResponse<VehicleTypeGroup>> {
  return instance.post(`/vehicle-type-group`, body)
}
